import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [delegates, setDelegates] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const loggedOut = useRef(false);
  const staff = auth && auth.kind === "staff" && !auth.must_change_password ? auth : null;
  const member = auth && auth.kind === "member" ? auth : null;

  const refresh = useCallback(async () => {
    const e = await api.get("/events");
    setEvents(e.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
    api.get("/auth/me").catch(() => api.post("/auth/refresh")).then((r) => setAuth(r.data)).catch(() => setAuth(false));
    const expire = () => setAuth(false);
    window.addEventListener("auth:expired", expire);
    return () => window.removeEventListener("auth:expired", expire);
  }, [refresh]);

  const staffId = staff?.id;
  const loadDelegates = useCallback((bg) => api.get("/delegates", bg === true ? { headers: { "X-Background": "1" } } : undefined).then((r) => setDelegates(r.data)).catch(() => {}), []);
  useEffect(() => {
    if (staffId) { loadDelegates(); } else { setDelegates([]); }
  }, [staffId, loadDelegates]);

  const value = {
    auth, member, session: staff, user: staff, role: staff?.role, delegates, events, loading, loggedOut, setAuth,
    refresh: async (bg) => { await Promise.all([refresh(), staffId ? loadDelegates(bg) : null]); },
    signIn: (u) => { loggedOut.current = false; setAuth(u); },
    logout: async () => { loggedOut.current = true; await api.post("/auth/logout").catch(() => {}); setAuth(false); },
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => useContext(AppContext);
export const useCanExport = () => useContext(AppContext)?.user?.can_export !== false;
